<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="xl"
      title="Localização"
    >
      <!-- <div>latitude: {{ latitude }}</div> -->
      <!-- <div>longitude: {{ longitude }}</div> -->
      <!-- {{ pin }} -->
      <div v-if="latitude == 0 && longitude == 0">
        <h4 class="danger">Essa ocorrência não possui localização</h4>
      </div>
      <!-- <base-path-map
        :latitude="pin.location.latitude"
        :longitude="pin.location.longitude"
      ></base-path-map> -->
      <base-map :apiKey="apiKey" :pin="pin"> </base-map>
      <template #modal-footer="{ ok }">
        <div class="right">
          <b-button variant="green" @click="ok()"> Fechar </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: "WorkflowMap",
  props: {
    latitude: Number,
    longitude: Number,
  },
  components: {
    BaseMap: () => import("@/components_rms/base/BaseMap.vue"),
    // BasePathMap: () => import("@/components_rms/base/BasePathMap.vue"),
  },
  data() {
    return {
      apiKey:
        "As-Vkf2McY-jBXfx3q_vrpwdrFmtyixvHjGFuv90Ak2WD338py0sIQ7wCf5z2D80", //chave da api
      pin: {
        key: "pin1",
        location: {
          latitude: 0,
          longitude: 0,
        },
        visible: true,
      },
    };
  },
  created() {
    if (this.latitude != 0) this.pin.location.latitude = this.latitude;
    if (this.longitude != 0) this.pin.location.longitude = this.longitude;
  },
  methods: {
    openModal() {
      this.$refs.openModal.show();
    },
    openMap(latitude, longitude) {
      this.pin.location.latitude = latitude;
      this.pin.location.longitude = longitude;
      this.$refs.openModal.show();
    },
  },
  watch: {
    latitude() {
      if (this.latitude != 0) this.pin.location.latitude = this.latitude;
    },
    longitude() {
      if (this.longitude != 0) this.pin.location.longitude = this.longitude;
    },
  },
};
</script>
<style scoped>
.danger {
  color: #fd5d93 !important;
}
</style>
